module.exports = __webpack_public_path__ + "static/media/women.154ed090.png";